<template>
  <div class="page page-reservation-main">
    <van-sidebar v-model="activeKey" @change="handleChange">
      <van-sidebar-item v-for="(item, index) in typeList" :title="item.title"/>
    </van-sidebar>
    <div class="plan-time-list">
      <div class="requirement">
        <div class="title">
          <van-icon name="warning-o"/>
          办理要求
        </div>
        <div class="info">{{ currentType.requirement }}</div>
      </div>
      <van-empty v-if="timeList.length === 0" image="error" description="没有可预约日期"/>
      <div v-else v-for="planTime in timeList" class="plan-date">
        <div class="date">
          <van-icon name="clock-o"/>
          {{ planTime.planDate }} {{ getWeekDay(planTime.planDate) }}
        </div>
        <div class="time" v-for="time in planTime.planList">
          <div class="time-title">
            {{ time.timeConfigTitle }}
            <span>{{ time.startTime }}-{{ time.endTime }}</span>
            <span>剩余:{{ time.maxNum - time.applyNum }}</span>
          </div>
          <van-button size="small" @click="handleClickApply(time)" :disabled="time.maxNum <= time.applyNum"
                      type="primary">立即预约
          </van-button>
        </div>
      </div>
    </div>
    <van-button @click="handleGoMy" style="position: fixed;bottom: 0;right: 0;left: 0;width: 100%;" type="info">我的预约
    </van-button>
    <van-dialog v-model="showConfirmDialog" :before-close="beforeClose" title="预约确认" :showCancelButton="true"
                :showConfirmButton="true">
      <div class='reservation-preview'>
        <div>
          预约内容：{{ time.typeTitle }}
        </div>
        <div>
          预约日期：{{ time.planDate }}
        </div>
        <div>
          预约时间：{{ time.startTime }}
        </div>
        <div>
          <van-checkbox style="margin-top: 5px;" v-model="isConfirm">
            我已阅读并同意<span @click.stop="goReservationNotice" class="reservation-span">预约须知</span>
          </van-checkbox>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import mixinLoad from '@/mixin/mixin-load.js';
import {checkService} from "@/api/user";
import {
  typeList,
  timeList,
  requestApply
} from '@/api/reservation.js';

const weekDay = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
export default {
  mixins: [mixinLoad],
  data() {
    return {
      activeKey: 0,
      typeList: [],
      currentType: {},
      timeList: [],
      time: {},
      showConfirmDialog: false,
      isConfirm: false
    };
  },
  methods: {
    getWeekDay(day) {
      return weekDay[new Date(day).getDay() - 1];
    },
    handleChange(index) {
      this.currentType = this.typeList[index];
      this.loadPlanList(this.currentType);
    },
    loadPlanList(typeItem) {
      const loading = this.showLoading();
      timeList({
        typeId: typeItem.id
      })
          .then(rep => {
            loading.clear();
            this.timeList = rep.data;
          })
          .catch(() => {
            loading.clear();
          });
    },
    handleClickApply(time) {
      this.time = time;
      this.showConfirmDialog = true;
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        if (this.isConfirm) {
          const loading = this.showLoading();
          requestApply({
            planUuid: this.time.uuid
          })
              .then(rep => {
                loading.clear();
                done();
                if (rep.code === 1) {
                  this.time.applyNum = this.time.applyNum + 1;
                  this.$dialog
                      .alert({
                        confirmButtonText: '查看我的预约',
                        message: '预约成功！\n请在约定时间及时办理相关业务^_^'
                      })
                      .then(() => {
                        this.handleGoMy();
                      });
                }
              })
              .catch(err => {
                done();
                loading.clear();
                if (err && err.msg.indexOf('约满') !== -1) {
                  this.loadPlanList(this.currentType);
                }
              });

        } else {
          this.$toast('请阅读并同意预约须知');
          done(false);
        }
      } else {
        done();
      }
    },
    goReservationNotice() {
      this.$router.push({
        path: '/public?code=reservation'
      });
    },
    handleGoMy() {
      this.$router.replace({
        path: '/reservation-my'
      });
    }
  },
  created() {
    checkService('needResign').then(() => {
      const loading = this.showLoading();
      typeList()
          .then(rep => {
            loading.clear();
            this.typeList = rep.data;
            this.handleChange(0);
          })
          .catch(() => {
            loading.clear();
          });
    });
  }
};
</script>

<style>
.page-reservation-main {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  padding-bottom: 44px;
}

.page-reservation-main .van-sidebar {
  width: 120px;
  background-color: #f7f8fa;
}

.page-reservation-main .plan-time-list {
  width: 200px;
  flex-grow: 1;
  min-height: 50vh;
}

.page-reservation-main .plan-date {
  margin: 10px;
}

.page-reservation-main .plan-date .date {
  background-color: #f7f8fa;
  padding: 8px;
  font-size: 16px;
}

.requirement {
  margin-left: 10px;
}

.requirement .title {
  background-color: #f7f8fa;
  padding: 8px;
  font-size: 18px;
}

.requirement .info {
  margin: 10px;
}

.page-reservation .plan-date .time .time-title {
  margin-top: 8px;
  margin-bottom: 8px;
}

.page-reservation .plan-date .time .time-title span {
  margin-right: 10px;
}

.reservation-preview {
  padding: 15px;
  text-align: left;
}

.reservation-preview div {
  margin-bottom: 5px;
}

.reservation-span {
  color: #1989fa;
}
</style>
